var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip-container",attrs:{"id":_vm.id}},[_c('span',{class:_vm.currentClassName,domProps:{"textContent":_vm._s(_vm.$t(_vm.localizationKey))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }